export function cleanObj<T>(data?: T): T | undefined {
    if (!data) return;

    const cleanedData: any = {};

    for (const key in data) {
        if (
            data[key] !== undefined &&
            data[key] !== null &&
            data[key]?.toString().trim() !== ''
        )
            cleanedData[key] = data[key];
    }

    return cleanedData;
}
